<script setup lang="ts">
import { computed } from 'vue'
import { MenubarTrigger, type MenubarTriggerProps, useForwardProps } from 'radix-vue'
import { cn } from '@/lib/utils'

type TClassProps = string | string[] | Record<string, boolean>

const props = defineProps<MenubarTriggerProps & { class?: TClassProps }>()

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
    <MenubarTrigger
        v-bind="forwardedProps"
        :class="
            cn(
                'data-[state=open]:text-plus-lp-green-one [&[data-state=open]>svg]:rotate-180',
                'h-full flex cursor-pointer gap-1 relative data-[state=open]:text-plus-lp-green-one select-none items-center outline-none data-[state=open]:text-plus-lp-green-one hover:text-plus-lp-green-one transition-all duration-400 [&[data-state=open]>span.v-icon]:rotate-180 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-focus',
                props.class,
            )
        "
    >
        <slot />
        <slot name="icon">
            <VIcon
                name="chevron-down"
                size="m"
                class="v-icon transition-transform duration-400"
            />
        </slot>
    </MenubarTrigger>
</template>
